<template>
  <b-container class="text-left p-0">
    <b-form-row class="row">
      <b-col :cols="2" v-html="suitSymbols.spades" class="mr-3"></b-col>
      <b-col :cols="6" v-html="convertCards(hand.Spades, 0)"></b-col>
    </b-form-row>
    <b-form-row class="row">
      <b-col :cols="2" v-html="suitSymbols.hearts" class="mr-3"></b-col>
      <b-col :cols="6" v-html="convertCards(hand.Hearts, 1)"></b-col>
    </b-form-row>
    <b-form-row class="row">
      <b-col :cols="2" v-html="suitSymbols.diams" class="mr-3"></b-col>
      <b-col :cols="6" v-html="convertCards(hand.Diamonds, 2)"></b-col>
    </b-form-row>
    <b-form-row class="row">
      <b-col :cols="2" v-html="suitSymbols.clubs" class="mr-3"></b-col>
      <b-col :cols="6" v-html="convertCards(hand.Clubs, 3)"></b-col>
    </b-form-row>
  </b-container>
</template>

<script>

import {suitHtml} from "../../lib/cardSuits";

export default {
  name: 'Hand',
  props: {
    hand: {
      type: Object,
      required: true
    },
    lead: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      suitSymbols: suitHtml
    };
  },
  computed: {
    baseLang() {
      return this.$i18n.messages[this.$i18n.locale];
    },
    leadSuit() {
      if (this.lead !== null) {
        return Math.floor(this.lead / 13);
      }
      return -1;
    },
    leadRank() {
      if (this.lead !== null) {
        return this.lead % 13;
      }
      return -1;
    }
  },
  methods: {
    convertCards(cards, suit) {
      const that = this;
      if (cards.length === 0) return '---';
      return cards.split('').map(card => {
        let textCard = that.baseLang.cards[card];

        const rankArray = [ "A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"];

        if(suit === this.leadSuit && rankArray.indexOf(card) === this.leadRank) {
          textCard = "<span class='leadCard'>" + textCard + "</span>";
        }
        return textCard;
      }).join('');
    }
  }
};
</script>

<style scoped>

.row {
  height: 25px;
  line-height: 20px;
}

/deep/ .leadCard {
  background-color: #fef3c7;
  color: #92400e;
  font-weight: bold;
  border-radius: 2px;
  padding: 0 2px;
}
</style>
